// TV webviews (Silk / Tizen / webOS) can leave an iframe's video layer unpainted until a resize.
export const kickRepaint = (el) => {
  [150, 900].forEach((ms) =>
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
      if (!el || !el.isConnected) return;
      el.style.transform = "translateZ(0.01px)";
      requestAnimationFrame(() => { if (el.isConnected) el.style.transform = ""; });
    }, ms)
  );
};
